// hooks/useViewportHeight.ts
import { useEffect } from "react";

const useViewportHeight = (): void => {
  useEffect(() => {
    const setVh = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };

    setVh(); // Initial set
    window.addEventListener("resize", setVh);

    return () => window.removeEventListener("resize", setVh);
  }, []);
};

export default useViewportHeight;
